<app-layout>
  <div class="row">
    <div class="col-12" *ngIf="kullaniciGrup">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{id === '0' ? 'Yeni Kullanıcı Grubu' : 'Kullanıcı Grubu Düzenle'}}</h4>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()"
                 [ngClass]="{'disabled':kullaniciGrup.isim.length===0}">
              Kaydet
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Kullanıcı Grubu Adı</div>
                <input type="text" class="form-control" placeholder="Şube adı" [(ngModel)]="kullaniciGrup.isim">
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <label class="form-label">Yetkiler</label>
                <app-loading-input *ngIf="!yetkiler"></app-loading-input>
                <div *ngIf="yetkiler">
                  <label class="form-check" *ngIf="yetkiler.length>1">
                    <input class="form-check-input" type="checkbox" (change)="selectAll()" [(ngModel)]="selectAllVal">
                    <span class="form-check-label">Tümünü Seç</span>
                  </label>
                  <label class="form-check" *ngFor="let yetki of yetkiler">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="yetki.checked"
                           (change)="selectAllUpdate()">
                    <span class="form-check-label">{{yetki.isim}}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Kullanıcılar</h3>
        </div>
        <app-kullanici-liste [source]="kullanicilar"
                             (updateKullanicilar)="getKullanicilar($event)"></app-kullanici-liste>
      </div>
    </div>
  </div>
</app-layout>
